<script setup lang="ts">
import {resolveRelations} from '~/utils/relations'

const {
  public: {baseUrl},
} = useRuntimeConfig()

const {fetch: fetchContactMeta} = useContactMeta()

const {data: initialData} = await useAsyncData('contact', () => fetchContactMeta())
const {data: meta} = useLivePreview({initialData: initialData.value, depth: 1})

const faqs = computed(() => resolveRelations(meta.value?.faqs))

const seo = meta.value?.meta

useSeoMeta({
  title: seo?.title,
  description: seo?.description,
  ogUrl: `${baseUrl}/contact`,
  ogTitle: seo?.ogTitle || seo?.title,
  ogDescription: seo?.ogDescription || seo?.description,
  ogImage: resolveMediaUrl(seo?.image),
  ogImageAlt: resolveMediaAlt(seo?.image),
})
</script>

<template>
  <Loader :pending="!meta">
    <Container class="screen-content px-2">
      <LayoutPageHeader :title="$t('contact.title')">
        <template #description>
          {{ $t('contact.description') }}
        </template>
      </LayoutPageHeader>

      <div class="relative flex flex-col items-start md:flex-row">
        <div class="relative z-10 w-full lg:w-1/2">
          <Motion
            :initial="{opacity: 0, y: 64}"
            :animate="{opacity: 1, y: 0}"
            :transition="{ease: [0.16, 1, 0.3, 1], duration: 1}"
          >
            <ContactForm />
          </Motion>
          <Motion
            :initial="{opacity: 0, y: 64}"
            :animate="{opacity: 1, y: 0}"
            :transition="{ease: [0.16, 1, 0.3, 1], duration: 1, delay: 0.1}"
          >
            <ContactBusinessCard class="absolute bottom-4 sm:left-4 lg:bottom-20 lg:w-2/3 xl:w-2/3" />
          </Motion>
        </div>

        <div class="z-0 mt-4 w-full px-0 py-8 md:-ml-4 md:mt-0 md:px-0 lg:w-1/2">
          <Motion
            :initial="{opacity: 0, y: 64}"
            :animate="{opacity: 1, y: 0}"
            :transition="{ease: [0.16, 1, 0.3, 1], duration: 1, delay: 0.2}"
          >
            <ContactFaq :faqs="faqs" class="rounded-lg bg-gray-50 px-4 py-8 bordershadow-gray md:pl-12 md:pr-8" />
          </Motion>
        </div>
      </div>
    </Container>
    <Container class="h-32"></Container>
  </Loader>
</template>
